module.exports = __webpack_public_path__ + "img/購買星座title.02151b5f.svg";